// upload-cancel.js - Cancel button for Upload-Lift preview
document.addEventListener('DOMContentLoaded', function () {
  const cancelBtn = document.getElementById('cf-cancel-btn');
  const previewContainer = document.getElementById('cf-preview-container');
  const previewImg = document.getElementById('cf-preview-img');
  const chooseBtn = document.getElementById('cf-choose-image');
  const progressText = document.getElementById('cf-progress-text');
  
  if (!cancelBtn || !previewContainer) return;

  function resetUploadState() {
    // Hide preview container
    if (previewContainer) {
      previewContainer.style.display = 'none';
    }
    
    // Clear preview image
    if (previewImg) {
      previewImg.src = '';
    }
    
    // Clear progress text
    if (progressText) {
      progressText.textContent = '';
    }
    
    // Re-enable choose button
    if (chooseBtn) {
      chooseBtn.removeAttribute('disabled');
      chooseBtn.removeAttribute('aria-disabled');
    }
    
    // Clear any Upload-Lift stored data
    if (window.UploadLift && window.UploadLift.clearUpload) {
      window.UploadLift.clearUpload();
    }
  }

  // Cancel button click handler
  cancelBtn.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    resetUploadState();
    
    // Return focus to choose button for accessibility
    if (chooseBtn) {
      setTimeout(function() {
        chooseBtn.focus();
      }, 100);
    }
  });
  
  // Keyboard support (Enter/Space)
  cancelBtn.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      cancelBtn.click();
    }
  });
});